import { FEATURES, checkFeatureFlag } from '@/features'
import { useUserStore } from '@/store/user'

export function canSeeAnalytics(): boolean {
  return checkFeatureFlag(FEATURES.NEW_AP_VIEW) && useUserStore().canAccessOperations
}
